/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Form from './Form/index'
import React from 'react'
import Related from './Related/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Related'
let newAddressTypeValueData = fromData.useDataFormat({ viewPath,
context: 'new_address',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: newAddressTypeValueData,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Related'}>
<Related
  viewPath={`${viewPath}/Related`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Form'}>
<Form
  viewPath={`${viewPath}/Form`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}